<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <DoctorQueueTable
      permission-key="dental_patients"
      endpoint="/dentalpatients"
      action-path="/treatment"
      action-label="Treatment"
      no-permission-text="You have no permission to View Dental Patients"
    />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DoctorQueueTable from "@/components/DoctorQueueTable.vue";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Dental Patients",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, DoctorQueueTable },
  data() {
    return {
      title: "Dental Patients",
      items: [{ text: "Dashboard", to: "/" }, { text: "Dental Patients", active: true }],
    };
  },
};
</script>
